// @flow weak

import './tooltip.css';

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { BiPlus, BiTrash } from 'react-icons/bi';

// *******************************************************
// HANDLE COMPONENT
// *******************************************************
export class Handle extends Component {
  state = {
    showTooltip: false,
  };

  getTimeFromMins(mins: number) {
    // Calculate hours and remaining minutes
    const hours = Math.floor(mins / 60);
    const remainingMinutes = mins % 60;

    // Format hours and minutes to always have two digits
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(remainingMinutes).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  }

  render() {
    const {
      domain: [min, max],
      handle: { id, value, percent },
      getHandleProps,
      addSlide,
      removeSlide,
    } = this.props;
    const { showTooltip } = this.state;

    const buttonStyle = {
      position: 'relative',
      top: -20,
      right: 5,
      zIndex: 10,
      display: 'block',
    };
    const isEndTime = id?.replace('$$-', '') % 2 !== 0;

    return (
      <React.Fragment>
        {/* {showTooltip ? (
          <div
            style={{
              left: `${percent}%`,
              position: "absolute",
              marginLeft: "-11px",
              marginTop: "-30px"
            }}
          >
            <div className="tooltip2">
              <span className="tooltiptext">Time: {value}:00</span>
            </div>
          </div>
        ) : null} */}
        <div
          style={{
            left: `${percent}%`,
            position: 'absolute',
            marginLeft: '-11px',
            marginTop: '-30px',
          }}
        >
          <div className="tooltip2">
            <span style={buttonStyle}>
              <button id="btn-plus-tooltip" onClick={addSlide}>
                <BiPlus size={18} color="#4167DA" />
              </button>

              {/* <button onClick={removeSlide}>
                <BiTrashAlt size={18} color="#4167DA" />
              </button> */}
            </span>

            <span
              className="tooltiptext"
              style={{
                marginBottom: isEndTime ? '15px' : 0,
              }}
            >
              {' '}
              {/* {moment(
                `${value}:${value % 1 !== 0 ? "30" : "00"}`,
                "hh:mm a"
              ).format("hh:mm a")} */}
              {this.getTimeFromMins(value)}
            </span>
          </div>
        </div>
        <div
          role="slider"
          aria-valuemin={min}
          aria-valuemax={max}
          aria-valuenow={value}
          style={{
            left: `${percent}%`,
            position: 'absolute',
            marginLeft: '-11px',
            marginTop: '-9px',
            zIndex: 2,
            width: 24,
            height: 24,
            cursor: 'pointer',
            borderRadius: '50%',
            // boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.4)",
            backgroundColor: '#ffffff',
            border: '2px solid #4167DA',
          }}
          {...getHandleProps(id, {
            onMouseLeave: () => {
              this.setState({
                showTooltip: false,
              });
            },
            onMouseOver: () => {
              this.setState({
                showTooltip: true,
              });
            },
          })}
        />
      </React.Fragment>
    );
  }
}

Handle.propTypes = {
  domain: PropTypes.array.isRequired,
  handle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getHandleProps: PropTypes.func.isRequired,
};

// *******************************************************
// TRACK COMPONENT
// *******************************************************
export function Track({ source, target, getTrackProps, removeSlide }) {
  return (
    <div className="trackCmp">
      <div
        style={{
          position: 'absolute',
          height: 8,
          zIndex: 1,
          backgroundColor: '#4167DA',
          borderRadius: 4,
          cursor: 'pointer',
          left: `${source.percent}%`,
          width: `${target.percent - source.percent}%`,
        }}
        {...getTrackProps()}
      ></div>
      <button
        id="btn-trash-components"
        onClick={removeSlide}
        style={{
          position: 'absolute',
          left: `${source.percent + (target.percent - source.percent) / 2 - 2}%`,
          right: 0,
          top: '-15px',
          zIndex: 3,
        }}
      >
        <BiTrash color="#4167DA" size={22} />
      </button>
    </div>
  );
}

Track.propTypes = {
  source: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  target: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getTrackProps: PropTypes.func.isRequired,
};

// *******************************************************
// TICK COMPONENT
// *******************************************************
export function Tick({ tick, count, format }) {
  return (
    <div>
      <div
        style={{
          position: 'absolute',
          marginTop: 14,
          width: 1,
          height: 5,
          backgroundColor: 'rgb(200,200,200)',
          left: `${tick.percent}%`,
        }}
      />
      <div
        style={{
          position: 'absolute',
          marginTop: 22,
          fontSize: 10,
          fontFamily: 'Arial',
          textAlign: 'center',
          marginLeft: `${-(100 / count) / 2}%`,
          width: `${100 / count}%`,
          left: `${tick.percent}%`,
        }}
      >
        {/* {moment(`${format(tick.value)}:00`, "hh:mm a").format("hh:mm a")} */}
      </div>
    </div>
  );
}

Tick.propTypes = {
  tick: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  count: PropTypes.number.isRequired,
  format: PropTypes.func.isRequired,
};

Tick.defaultProps = {
  format: d => d,
};
